// extracted by mini-css-extract-plugin
export default {"label":"TextfieldComponent_label__T-krS"};